import { extractArrayFromQuery } from '@/utils/query';

export const genderOptions = [
  'Man',
  'Woman',
  'Agender',
  'Gender Fluid',
  'Gender Non-conforming',
  'Genderqueer',
  'Non-binary',
  'Questioning',
  'Self Identify Another Option',
  'Prefer Not to Say'
];
export function genderValues(search) {
  if (!search || !search.genders || !search.genders.length) return undefined;
  const genders = extractArrayFromQuery(search, 'genders')
  return genders.map(gender => genderOptions[gender - 1])
}

export default {
  param: extractArrayFromQuery,
  query: function (values) {
    if (values.length > 0) {
      return {
        gender: {
          $in: values.map(function(value) {
            return genderOptions[Number(value) - 1];
          })
        }
      }
    }
  }
}
